import { Fragment, useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";

import { sendFax } from "../../../../../features/fax/fax";

import { inputValueToInt } from "../../../../../utils/utils"

import { Checkbox, FormControl, FormControlLabel, MenuItem, OutlinedInput, Radio, Select } from "@mui/material";
import PdfPreview from "../../../../../components/PdfPreview";
import { createVerticalOrderFormPDF } from "../../../../../features/pdf/VerticalOrderFormPDF";
import { createHorizontalOrderFormPDF } from "../../../../../features/pdf/HorizontalOrderFormPDF";
import { SelectDestinationDrawer } from "../../../../../components/drawers/SelectDestinationDrawer";
import { createVerticalOrderCheckFormPDF } from "../../../../../features/pdf/VerticalOrderCheckFormPDF";
import { createHorizontalOrderCheckFormPDF } from "../../../../../features/pdf/HorizontalOrderCheckFormPDF";
import { postMarketPriceUpdateShippingDateInfoAPI } from "../../../../../http/api/MarketPriceAPI";
import { getShopsGroupingByCustomer } from "../../../../../utils/customerShop";
import { createGeneralOrderFormPDF } from "../../../../../features/pdf/GeneralOrderFormPDF";
import { createGeneralOrderCheckFormPDF } from "../../../../../features/pdf/GeneralOrderCheckFormPDF";
import { getUsingDirectorEmployeePartition, getUsingDeliveryPrice, validatePrintPageStr } from "../../../../../utils/orderForm";
import { OrderFormPdfSettingPart } from "./OrderFormPdfSettingPart";
import { OrderNumberPdfSettingPart } from "./OrderNumberPdfSettingPart";
import { controlPdfSettingConstraint } from "./SettingConstraints";

function PdfSettingPart({onlyPdf, ...props}) {

	return onlyPdf
		? <OrderNumberPdfSettingPart {...props} />
		: <OrderFormPdfSettingPart {...props} />
	;
}

// fax送付dialog
// props ...
//   open = ダイアログを開いていればtrue
//   onClose = ダイアログを閉じるときの処理 (event) => void
//   sendProps = 送信プロパティ
export function SendFaxDialog({open, onClose, sendProps, setIsLoading}) {

	const { shippingDateInfo, marketPriceTableInfo, shops: initShops, onlyPdf } = sendProps;

	const [pdfStatus, setPdfStatus] = useState({
		url: "",
		initialized: false
	});
	const [shops, setShops] = useState([]);
	//const [selectDestinationDrawerOpen, setSelectDestinationDrawerOpen] = useState(false)

	const getCreatePdfFunction = (pdfSetting) => {
		if (pdfSetting.general === "1") {

			return onlyPdf ? createGeneralOrderCheckFormPDF : createGeneralOrderFormPDF;
		}
		if (pdfSetting.direction === "1") {
			return onlyPdf ? createVerticalOrderCheckFormPDF : createVerticalOrderFormPDF;
		}
		return onlyPdf ? createHorizontalOrderCheckFormPDF : createHorizontalOrderFormPDF;
	}

  // 出荷日が期間指定されているかを取得する
  const getShippingDateIsInterval = (shippingDateInfo) => {
    return Boolean(shippingDateInfo.shippingDateFrom) && Boolean(shippingDateInfo.shippingDateTo);
  }

	// 出荷日を期間区分けにできるかを取得する
	const enableDatePartition = (marketPriceTableInfo, shippingDateInfo) => {
		return (marketPriceTableInfo.orderFormColumnCountDirectionCd == '1'
				|| marketPriceTableInfo.orderFormColumnCountDirectionCd == '3'
			) && getShippingDateIsInterval(shippingDateInfo)
	}

	// 取引先ごとの出力形式設定初期値を取得する
	const getInitialPdfSetting = (marketPriceTableInfo) => controlPdfSettingConstraint({
		orderFormColumnCountDirectionCd: marketPriceTableInfo.orderFormColumnCountDirectionCd.toString(),
		columnNumber : ["0", "1", "2", "1", "3", "2"][marketPriceTableInfo.orderFormColumnCountDirectionCd],
		shopSummary: marketPriceTableInfo.orderFormShopSummaryCd.toString(),
		productTypePartition: marketPriceTableInfo.orderFormProductTypePartitionCd.toString(),
		directorEmployeePartition: onlyPdf ? marketPriceTableInfo.orderFormDirectorEmployeePartitionCd.toString() : "2",
		direction: ["0", "1", "2", "2", "2", "1"][marketPriceTableInfo.orderFormColumnCountDirectionCd],
		general:  marketPriceTableInfo.orderFormColumnCountDirectionCd === 4 ? "1" : "2",
		unitPrice: marketPriceTableInfo.unitPriceCd.toString(),
		deadlineHourOutput: marketPriceTableInfo.orderFormDeadlineHourOutputCd.toString(),
		contact: marketPriceTableInfo.orderFormContactCd.toString(),
		orderQuantityOutput: (onlyPdf ? "1" : marketPriceTableInfo.orderFormOrderQuantityOutputCd.toString()),
		destinationOutputCd: marketPriceTableInfo.destinationOutputCd.toString(),
		skipNoOrder: false,
		skipOrderUnit: false,
		datePartition: enableDatePartition(marketPriceTableInfo, shippingDateInfo),
		skipRemark:
			enableDatePartition(marketPriceTableInfo, shippingDateInfo)
				|| marketPriceTableInfo.isUsingSellingPrice
				|| (getUsingDeliveryPrice(marketPriceTableInfo.deliveryPriceAdditionCd) && onlyPdf),
    isUsingSellingPrice: marketPriceTableInfo.isUsingSellingPrice,
    // 納品価格表示フラグ：納品価格加算コードが「なし」以外の場合にTRUE
		isUsingDeliveryPrice: getUsingDeliveryPrice(marketPriceTableInfo.deliveryPriceAdditionCd),
    // 元市況価格表示フラグ：売価表示かつ注文票PDF作成時、または売価非表示かつ納品価格加算コードが「なし」以外の場合にTRUE
		isUsingOriginalMarketPrice:
			(marketPriceTableInfo.isUsingSellingPrice && onlyPdf)
			|| (!marketPriceTableInfo.isUsingSellingPrice && getUsingDeliveryPrice(marketPriceTableInfo.deliveryPriceAdditionCd)),
    isViewOriginalCost: false,
		printPageStr: "",
		isSendingAgain: false,
		outputPrice: true,
		asSendingLabel: false
	})
  
  const getCreatePdfSetting = (pdfSetting) => ({
    ...pdfSetting,
    columnNumber: inputValueToInt(pdfSetting.columnNumber),
    shopSummary : pdfSetting.shopSummary === "2",
    productTypePartition: pdfSetting.productTypePartition === "1",
    directorEmployeePartition: pdfSetting.directorEmployeePartition === "1",
    deadlineHourOutput: pdfSetting.deadlineHourOutput === "1",
		unitPrice: inputValueToInt(pdfSetting.unitPrice),
		contact: inputValueToInt(pdfSetting.contact),
    orderQuantityOutput: pdfSetting.orderQuantityOutput === "1",
		destinationOutputCd: inputValueToInt(pdfSetting.destinationOutputCd),
  });

	useEffect (() => {
		if (open) {

			//setSelectDestinationDrawerOpen(false);
			const initPdfSetting = getInitialPdfSetting(marketPriceTableInfo);

			const customerShopInfo = getShopsGroupingByCustomer(initShops);
			const newCustomers = customerShopInfo.map((customerShopInfo) => ({
				customerId: customerShopInfo.customerId,
				customerName: customerShopInfo.customerName,
				customerFax: customerShopInfo.shops[0].customerFax,
				shopId: null,
				shopName: "",
				isSelected: false
			}));

			const newShops = initShops.map((shopInfo) => ({
				...shopInfo,
				isSelected: true
			}))

			const newCustomerShopList = [...newCustomers, ...newShops];

			setShops(newCustomerShopList);

			(async () => {
				await createPdfPreview(newCustomerShopList, initPdfSetting);
			})()
		} else {
			if (pdfStatus.url) {
				URL.revokeObjectURL(pdfStatus.url);
			} 

			setPdfStatus({
				url: "",
				initialized: false
			})
		}
	}, [open])
	
	const onChangePdfSetting = (pdfSetting) => {
		
		let url = "";

		if (open && pdfStatus.initialized) {
			if (pdfStatus.url) {
				URL.revokeObjectURL(pdfStatus.url);
			} 

			setPdfStatus({
				...pdfStatus,
				url: ""
			});

			(async () => {
				url = await createPdfPreview(shops, pdfSetting);
			})();
		}

		return () => {
			if (url) {
				URL.revokeObjectURL(url);
			} 
		}
	}

	// プレビュー用PDF作成
	const createPdfPreview = async (shops, pdfSetting) => {
		let createPdfSetting = getCreatePdfSetting(pdfSetting);

		let pdfBytes 
			= (await getCreatePdfFunction(pdfSetting)(
					marketPriceTableInfo.marketPriceId,
					shops.filter((shopInfo) => shopInfo.shopName),
					getSelectedShopInfoList(shops),
					true,
					shippingDateInfo,
					createPdfSetting,
					marketPriceTableInfo.marketPriceHistoryDate
				))[0];  
		const file = new Blob([pdfBytes], {type: "application/pdf"});

		const url = URL.createObjectURL(file);
		setPdfStatus({url, initialized: true});
		return url;
	}

	// 上の内容で注文票FAX送信する　を押下時の挙動
	// FAX送付中止
	// const onClickSendFaxConfirm = async (event) => {
	// 	try {
	// 		setIsLoading(true);
	// 		//Fax作業スタート
	// 		let selectedShops = getSelectedShopInfoList(shops);

	// 		let createPdfSetting = getCreatePdfSetting(pdfSetting);

	// 		let pdfBytesList = await getCreatePdfFunction(pdfSetting)(
	// 				marketPriceTableInfo.marketPriceId,
	// 				shops.filter((shopInfo) => shopInfo.shopName),
	// 				getSelectedShopInfoList(shops),
	// 				false,
	// 				shippingDateInfo,
	// 				createPdfSetting,
	// 				marketPriceTableInfo.marketPriceHistoryDate
	// 		);

	// 		let sendFaxPropsList = selectedShops.map((shopInfo, i) => ({        
	// 			faxFileUrl : URL.createObjectURL(new Blob([pdfBytesList[i]], {type: "application/pdf"})),
	// 			faxNumbers : [shopInfo.shopFax ? shopInfo.shopFax : shopInfo.customerFax ]
	// 		}));

	// 		await sendFax(sendFaxPropsList);

	// 		// 出荷日更新
	// 		await postMarketPriceUpdateShippingDateInfoAPI({
	// 			marketPriceId: marketPriceTableInfo.marketPriceId,
	// 			...shippingDateInfo  
	// 		});

	// 		marketPriceTableInfo.shippingDateFrom = shippingDateInfo.shippingDateFrom;
	// 		marketPriceTableInfo.shippingDateTo = shippingDateInfo.shippingDateTo;
	// 		//Fax作業終わり

	// 		alert("faxを送付しました。");
	// 	} catch (err) {
	// 		console.log(err);
	// 		alert("faxの送付に失敗しました。");
	// 	}
	// 	finally {
	// 		setIsLoading(false);
	// 		onClose(event);
	// 	}
	// }

	const getSelectedShopInfoList = (shops) => {
		return shops.filter((shopInfo) => (shopInfo.isSelected));
	}

	// const onClickSelectDestination = (event) => {
	// 	setSelectDestinationDrawerOpen(true);
	// }

	// const closeSelectDestination = (event) => {
	// 	setSelectDestinationDrawerOpen(false);
	// }

	return (
		<Dialog
			open={open}
			onClose={onClose}
			fullScreen
			PaperProps={{
				style:{
					overflowX: "hidden"
				}
			}}
		>
			<Box padding={2}>

				<Grid container alignItems="center">
					<Grid item xs>
						<Typography>注文票PDFプレビュー</Typography>
					</Grid>
					{/* <Grid item xs='auto' display={onlyPdf ? "none" : "block"}>
						<Button variant="contained" onClick={onClickSelectDestination}>送信先選択</Button>
					</Grid> */}
				</Grid>
						
				<Box height="calc(100vh - 350px)" marginY={1}>
					<PdfPreview pdfUrl={pdfStatus.url} />
				</Box>
											
				<Box marginY={1}>
					<PdfSettingPart
						onlyPdf={onlyPdf} shippingDateIsInterval={getShippingDateIsInterval(shippingDateInfo)}
						onLoadPdfSetting={() => getInitialPdfSetting(marketPriceTableInfo)} onChangePdfSetting={onChangePdfSetting}
					/>
				</Box>

				<Box MarginTop={1}>
					<Grid container spacing={1}>
						<Grid item xs />
						<Grid item xs="auto">
							<Button variant="outlined" onClick={onClose}>戻る</Button>
						</Grid>
						{/* FAX送付中止 */}
						{/* <Grid item xs="auto" display={onlyPdf ? "none" : "block"}>
							<Button
								variant="contained"
								onClick={onClickSendFaxConfirm}
								disabled={getSelectedShopInfoList(shops).length === 0}
							>
								上の内容で注文票FAX送信する
							</Button>
						</Grid>    */}
					</Grid>
				</Box>        
			</Box>

			{/* <SelectDestinationDrawer
				open={selectDestinationDrawerOpen}
				onClose={closeSelectDestination}
				params={{
					shops: shops,
					setShops: setShops
				}}
			/> */}
		</Dialog>
	)
}
  